module.exports = __webpack_public_path__ + "ec628c9768179ea19cbcc62b5198975e.png";